export enum EventInsuranceType {
  REVIEW = "review",
  COLLISION = "collision",
  THEFT = "theft",
  MOTORCYCLE_RETRIEVAL = "motorcycle_retrieval",
  WHEEL_OR_TIRE_DAMAGE = "wheel_or_tire_damage",
  KEY_REPLACEMENT = "key_replacement",
  WITHDRAWAL_CANCELLATION = "withdrawal_cancellation",
  OUT_OF_COVERAGE_RADIUS = "out_of_coverage_radius",
  MAINTENANCE_WITHOUT_SCHEDULING = "maintenance_without_scheduling",
  NO_SHOW = "no_show",
  MOTORCYCLE_SEIZURE = "motorcycle_seizure",
  BLOCKED_FOR_NONPAYMENT = "blocked_for_nonpayment",
  MISCONDUCT_OR_ABUSE = "misconduct_or_abuse",
}

export enum VehicleInsuranceType {
  CAR = "car",
  MOTORCYCLE = "motorcycle",
  TRUCK = "truck",
}

export enum VehicleClaimProcessStage {
  NOTICE = "notice",
  NOTICE_VALIDATION = "notice_validation",
  ADJUSTMENT = "adjustment",
  ADJUSTMENT_SUPERVISION = "adjustment_supervision",
  INVESTIGATION = "investigation",
  INVESTIGATION_VALIDATION = "investigation_validation",
  PURCHASE = "purchase",
  IN_WORKSHOP = "in_workshop",
  QUALITY_INSPECTION = "quality_inspection",
  SOLIDY_EXPERIENCE_SURVEY = "solidy_experience_survey",
}

export type EventClaim = {
  _id?: string; // ID do sinistro
  companyId?: string; // ID da empresa
  eventType: string; // Tipo do evento
  eventDate: string; // Data/Hora (formato: DD/MM/AAAA hh:mm  )
  location: string; // Local do evento
  state: string; // Estado
  city: string; // Cidade
  licensePlate: string; // Placa
  associateName: string; // Nome do associado
  vehicleType: string; // Tipo de veículo
  phone: string; // Telefone
  whatsapp: string; // Telefone WhatsApp
  email: string; // Email
  reportText: string; // Relato (campo livre)
  status: string; // Status do sinistro
  documents: EventDocuments[]; // Documentos do sinistro
  associatedTrigger: boolean; // Indica se o sinistro está associado a um gatilho
  thirdPartiesInvolved: boolean; // Indica se há terceiros envolvidos
  thirdPartiesCount: number; // Número de terceiros envolvidos
  thirdParties: EventThirdParty[]; // Lista de terceiros envolvidos
  createdAt?: string; // Data de criação do sinistro
  updatedAt?: string; // Data de atualização do sinistro
  author?: string;
};

export type EventThirdParty = {
  name: string; // Nome do terceiro
  licensePlate: string; // Placa do veículo do terceiro
  phone: string; // Telefone do terceiro
  eventThirdPartyType: string; // Tipo do evento
};

export type EventDocuments = {
  type?: string;
  content?: string;
  file?: unknown;
  verified?: boolean;
};

export enum VehicleClaimRequiredDocuments {
  MEMBER_CRLV = "member_crlv", // CRLV do Associado
  MEMBER_DRIVER_LICENSE = "member_driver_license", // CNH do Associado ou Condutor
  INCIDENT_REPORT_PDF = "incident_report_pdf", // Boletim de Ocorrência em PDF
  LAST_PAYMENT_RECEIPT = "last_payment_receipt", // Comprovante de Pagamento da Última Mensalidade
  THIRD_PARTY_CRLV = "third_party_crlv", // CRLV do Terceiro
  THIRD_PARTY_DRIVER_LICENSE = "third_party_driver_license", // CNH do Terceiro
  ANOTHER_PHOTO = "another_photo", // Registro da Eventualidade (Foto do Evento)
}
